export const newEventData = [
  {
    timeDisplay: "vier, 17 dic 2021, 19:00 GTM-03",
    title: `✨ Meetup Noviembre! Cómo crear un producto con React+NextJS + Web de ReactBA`,
    content: `Hola a todas/os! Y llegamos al final de 2022 😲, pero todavía nos queda una meetup más 🚀`,
    attendees: 82,
  },
  {
    timeDisplay: "vier, 12 nov 2021, 19:00 GTM-03",
    title: `✨ Meetup Noviembre! Tu aplicación production-ready con buenas prácticas ✨🤩`,
    content: `🗣️ "Tu aplicación production-ready con las mejores practicas" - Ernesto Moyano`,
    attendees: 176,
  },
];
